import { render } from "./AddImgBox.vue?vue&type=template&id=572628e7"
import script from "./AddImgBox.vue?vue&type=script&lang=js"
export * from "./AddImgBox.vue?vue&type=script&lang=js"

import "./AddImgBox.vue?vue&type=style&index=0&id=572628e7&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__